import { useState, useEffect, useCallback } from 'react';
import { db } from '../config/firebaseConfig.js'; 
import { collection, doc, onSnapshot, updateDoc, writeBatch, addDoc, deleteDoc } from 'firebase/firestore'; 

import ClassListView from '../bilesenler/Siniflar/ClassListView.js';
import StudentGridView from '../bilesenler/Siniflar/StudentGridView.js';
import ClassroomHeader from '../bilesenler/Siniflar/ClassroomHeader.js';
import { BONUS_CARDS } from '../bilesenler/Siniflar/CardData.js'; 

export default function ClassroomTool() {
    const [selectedClass, setSelectedClass] = useState(null);
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [classrooms, setClassrooms] = useState([]);
    
    // YENİ: DÜZENLEME MODU STATE'İ ANA MERKEZE EKLENDİ
    const [isEditMode, setIsEditMode] = useState(false);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, 'classrooms'), (snapshot) => {
            const classData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            classData.sort((a, b) => a.id.localeCompare(b.id));
            setClassrooms(classData);
        });
        return () => unsub();
    }, []);

    useEffect(() => {
        if (!selectedClass) { 
            setStudents([]); 
            setIsEditMode(false); // Sınıftan çıkınca düzenleme modunu sıfırla
            return; 
        }
        setLoading(true);
        const unsub = onSnapshot(collection(db, `classrooms/${selectedClass}/students`), (snap) => {
            setStudents(snap.docs.map(d => ({ id: d.id, ...d.data() })));
            setLoading(false);
        });
        return () => unsub();
    }, [selectedClass]);

    const handleCreateClass = async (className, classIcon) => {
        try {
            await addDoc(collection(db, 'classrooms'), { name: className, icon: classIcon, createdAt: new Date() });
        } catch (error) { console.error("Sınıf eklenirken hata oluştu:", error); }
    };

    const handleDeleteClass = async (classId) => {
        try { await deleteDoc(doc(db, 'classrooms', classId)); } 
        catch (error) { console.error("Sınıf silinirken hata:", error); }
    };

    const handleUpdateClass = async (classId, newName, newIcon) => {
        try { await updateDoc(doc(db, 'classrooms', classId), { name: newName, icon: newIcon }); } 
        catch (error) { console.error("Sınıf güncellenirken hata:", error); }
    };

    const handleScoreChange = useCallback(async (sid, val) => {
        if (!selectedClass) return;
        await updateDoc(doc(db, `classrooms/${selectedClass}/students`, sid), { score: Math.max(0, val) });
    }, [selectedClass]);

    const handleAvatarUpdate = useCallback(async (sid, avid) => {
        if (!selectedClass) return;
        await updateDoc(doc(db, `classrooms/${selectedClass}/students`, sid), { avatarId: avid });
    }, [selectedClass]);
    
    const handleWholeClassUpdate = useCallback(async (delta) => {
        if (!selectedClass || students.length === 0) return;
        const batch = writeBatch(db); 
        students.forEach(student => {
            const studentRef = doc(db, `classrooms/${selectedClass}/students`, student.id);
            const newScore = Math.max(0, student.score + delta);
            batch.update(studentRef, { score: newScore });
        });
        try { await batch.commit(); } 
        catch (error) { console.error("Toplu puan güncelleme hatası:", error); }
    }, [selectedClass, students]);

    const handleAddStudent = async (name) => {
        if (!selectedClass || !name) return;
        await addDoc(collection(db, `classrooms/${selectedClass}/students`), {
            name: name, score: 0, avatarId: 1, cards: []
        });
    };

    const handleDeleteStudent = async (sid, name) => {
        if (!selectedClass || !window.confirm(`${name} isimli öğrenciyi kalıcı olarak silmek istediğine emin misin?`)) return;
        await deleteDoc(doc(db, `classrooms/${selectedClass}/students`, sid));
    };

    const handleEditStudent = async (sid, oldName) => {
        const newName = window.prompt("Yeni adı girin:", oldName);
        if (!newName || newName === oldName) return;
        await updateDoc(doc(db, `classrooms/${selectedClass}/students`, sid), { name: newName.toUpperCase() });
    };

    const handleBuyCard = async (student) => {
        if (student.score < 30) {
            alert(`Yetersiz Enerji!\nÖdül almak için 30 enerjiye ihtiyacın var. (Mevcut: ${student.score})`);
            return;
        }
        if(!window.confirm(`${student.name} 30 enerji harcayarak rastgele bir Kozmik Kart alacak. Onaylıyor musun?`)) return;

        const randomCard = BONUS_CARDS[Math.floor(Math.random() * BONUS_CARDS.length)];
        const currentCards = student.cards || [];

        await updateDoc(doc(db, `classrooms/${selectedClass}/students`, student.id), {
            score: student.score - 30,
            cards: [...currentCards, randomCard]
        });
        alert(`🎉 İKMAL BAŞARILI! 🎉\n\nKazanılan Donanım: ${randomCard.icon} ${randomCard.name}\nÖzellik: ${randomCard.desc}`);
    };

    const handleUseCard = async (student, cardIndex) => {
        const cardToUse = student.cards[cardIndex];
        if(!window.confirm(`${cardToUse.icon} ${cardToUse.name} modülünü AKTİFLEŞTİRMEK ve silmek istiyor musun?\n(${cardToUse.desc})`)) return;

        const newCards = [...student.cards];
        newCards.splice(cardIndex, 1);
        await updateDoc(doc(db, `classrooms/${selectedClass}/students`, student.id), { cards: newCards });
    };

    const activeClassObj = classrooms.find(c => c.id === selectedClass);
    const activeClassName = activeClassObj ? (activeClassObj.name || activeClassObj.id) : selectedClass;

    return (
        <div className="ct-container" style={{ minHeight: '100vh', background: 'radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%)', color: '#e0f2fe', fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif' }}>
            <ClassroomHeader 
                selectedClass={activeClassName} 
                onBack={() => setSelectedClass(null)}
                students={students} 
                onScoreChange={handleScoreChange}
                isEditMode={isEditMode} // YENİ: Durumu Header'a ilet
                onToggleEditMode={() => setIsEditMode(!isEditMode)} // YENİ: Butona basılınca tetiklenecek fonksiyon
            />
            <main className="ct-main-content" style={{ padding: '0 15px' }}>
                {!selectedClass ? (
                    <div style={{ width: '100%', height: '100%', overflowY: 'auto' }}>
                        <ClassListView 
                            classrooms={classrooms} 
                            onClassSelect={setSelectedClass} 
                            onUpdateClass={handleUpdateClass} 
                            onCreateClass={handleCreateClass}
                            onDeleteClass={handleDeleteClass} 
                        />
                    </div>
                ) : (
                    <StudentGridView
                        students={students}
                        loading={loading}
                        isEditMode={isEditMode} // YENİ: Durumu ızgaraya (kartlara) ilet
                        onScoreChange={handleScoreChange}
                        onAvatarUpdate={handleAvatarUpdate}
                        onWholeClassUpdate={handleWholeClassUpdate} 
                        onAddStudent={handleAddStudent}
                        onDeleteStudent={handleDeleteStudent}
                        onEditStudent={handleEditStudent}
                        onBuyCard={handleBuyCard}
                        onUseCard={handleUseCard}
                    />
                )}
            </main>
        </div>
    );
}